import React from 'react';
import Button from '../Button/Button';
import './EmptyStateEnhanced.css';

interface EmptyStateEnhancedProps {
  icon?: React.ReactNode;
  title: string;
  subtitle: string;
  buttonText?: string;
  onButtonClick?: () => void;
  fullView?: boolean;
}

const EmptyStateEnhanced: React.FC<EmptyStateEnhancedProps> = ({
  icon,
  title,
  subtitle,
  buttonText,
  onButtonClick,
  fullView = false
}) => {
  return (
    <div className={`enhanced-empty-state ${fullView ? 'full-view' : ''}`}>
      {icon && (
        <div className="enhanced-empty-state-icon">
          {icon}
        </div>
      )}
      <h3 className="enhanced-empty-state-title">{title}</h3>
      <p className="enhanced-empty-state-subtitle">
        {subtitle}
      </p>
      {buttonText && onButtonClick && (
        <Button
          variant="primary"
          size="medium"
          onClick={onButtonClick}
          className="enhanced-empty-state-button"
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
};

export default EmptyStateEnhanced; 